module.exports = __webpack_public_path__ + "img/toupian.8732bfb5.png";